'use strict';
angular.module('attractions').config(function ($routeProvider) {

    function isMobileSite() {
        return TRPCONFIG.IsMobileView;
    }

    function getCookie(key) {
        // this logic has been duplicated from CookieService which we can't access here
        if (!key) { return null; }
        return decodeURIComponent(document.cookie.replace(
            new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(key)
                .replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1'))
            || null;
    }

    function getBookingFormTemplate(area) {
        if (!TRPCONFIG.Domain.isAgentMode && !isMobileSite()) {
            const version = parseFloat(TRPCONFIG.Domain.BookingFormVersion);
            if (version > 2) {
                if (TRPCONFIG.Domain.BookingFormABTest) {
                    if (!TRPCONFIG.Domain.isAgentMode) {
                        const cookieVersion = getCookie('BookingFormVersion');
                        if (cookieVersion && parseFloat(cookieVersion) > 2) {
                            return `partials/booking/template?name=Book&version=${cookieVersion}`;
                        }
                    }
                } else {
                    return `partials/booking/template?name=Book&version=${version}`;
                }
            }
        }
        return `partials/${area}/book`;
    }
    if (TRPCONFIG.Domain.SupportedProducts & 64) {
        let area = 'attractions';
        $routeProvider.when('/' + area + '/basket', {
            templateUrl: 'partials/'+ area + '/basket',
            controllerAs: 'cm',
            controller: 'AttractionsBasket',
            area: area,
            hideDistractionLinks: true,
            analyticsTag: 'Attractions Basket'
        });

        $routeProvider.when('/' + area + '/book/:tripId', {
            templateUrl: getBookingFormTemplate(area),
            controllerAs: 'cm',
            controller: 'Booking',
            area: area,
            noGroup: true,
            hideDistractionLinks: true,
            analyticsTag: 'Booking Form'
        });

        $routeProvider.when('/' + area + '/book/:tripId/passenger/:room/:index', {
            templateUrl: 'partials/' + area + '/passenger',
            controllerAs: 'cm',
            controller: 'Passenger',
            hideDistractionLinks: true,
            hideTravelAgentLinks: true
        });
    }

});
